var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70727 5.37627C4.70727 5.07053 4.45941 4.82267 4.15367 4.82267C3.84793 4.82267 3.60007 5.07053 3.60007 5.37627H4.70727ZM3.60007 10.9122C3.60007 11.218 3.84793 11.4658 4.15367 11.4658C4.45941 11.4658 4.70727 11.218 4.70727 10.9122H3.60007ZM2.76968 2.60828H8.30564V1.50109H2.76968V2.60828ZM9.41284 3.71548V9.25145H10.52V3.71548H9.41284ZM8.30564 10.3586H2.76968V11.4658H8.30564V10.3586ZM1.66248 9.25145V3.71548H0.55529V9.25145H1.66248ZM2.76968 10.3586C2.15819 10.3586 1.66248 9.86293 1.66248 9.25145H0.55529C0.55529 10.4744 1.5467 11.4658 2.76968 11.4658V10.3586ZM9.41284 9.25145C9.41284 9.86293 8.91713 10.3586 8.30564 10.3586V11.4658C9.52862 11.4658 10.52 10.4744 10.52 9.25145H9.41284ZM8.30564 2.60828C8.91713 2.60828 9.41284 3.10399 9.41284 3.71548H10.52C10.52 2.49251 9.52862 1.50109 8.30564 1.50109V2.60828ZM2.76968 1.50109C1.5467 1.50109 0.55529 2.49251 0.55529 3.71548H1.66248C1.66248 3.10399 2.15819 2.60828 2.76968 2.60828V1.50109ZM3.60007 5.37627V10.9122H4.70727V5.37627H3.60007ZM1.38569 5.65307H9.68964V4.54587H1.38569V5.65307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaDashboard);
export default __webpack_public_path__ + "static/media/icona-dashboard.01a51ea7f9952cf31dfc51319aea7dfc.svg";
export { ForwardRef as ReactComponent };